import "./HorizontalGraph.css";
import PropTypes from "prop-types";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import HorizontalGraphTooltip from "./HorizontalGraphTooltip/HorizontalGraphTooltip";
import { useGetStatsQuery } from "../../../queries/Stats";

const HorizontalGraph = ({ containerClassName }) => {
  const { isSuccess, data } = useGetStatsQuery();

  return (
    <div className={"horizontal-graph" + (!!containerClassName ? ` ${containerClassName}` : "")}>
      <ResponsiveContainer>
        <LineChart
          data={data?.client_graph_data}
          margin={{ top: 0, right: 0, bottom: 5, left: -25 }}
        >
          {isSuccess && (
            <>
              <CartesianGrid
                verticalFill={["#0A2A46", "#0E3557"]}
                stroke="#295F83"
                strokeLinecap="round"
                strokeWidth={0}
              />
              <XAxis
                dataKey="month"
                axisLine={false}
                tickLine={false}
                orientation="top"
                stroke="#89aabb"
                tickMargin={8}
                allowDecimals={false}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                stroke="#295F83"
                tickCount={4}
                type="number"
                domain={[0, "dataMax"]}
                padding={{ top: 10, bottom: 0 }}
                allowDecimals={false}
              />
              <Tooltip content={<HorizontalGraphTooltip />} />
              <Line
                type="linear"
                dataKey="voted_up"
                stroke="#509ec6"
                activeDot={{ stroke: "transparent" }}
                strokeWidth={2}
                strokeDasharray="2 2"
                dot={false}
              />
              <Line
                type="linear"
                dataKey="voted_down"
                stroke="#FF7BAC"
                activeDot={{ stroke: "transparent" }}
                strokeWidth={2}
                strokeDasharray="4 6"
                dot={false}
              />
              <Line
                type="linear"
                dataKey="interviewed"
                stroke="#5B7E95"
                activeDot={{ stroke: "transparent" }}
                strokeWidth={2}
                strokeDasharray="2 6"
                dot={false}
              />
              <Line
                type="linear"
                dataKey="hired"
                stroke="#21D4D2"
                activeDot={{ stroke: "transparent" }}
                strokeWidth={2}
                dot={false}
              />
            </>
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

HorizontalGraph.propTypes = {
  containerClassName: PropTypes.string,
};

export default HorizontalGraph;
